import { Flex } from "antd";
import { enToBnNumber } from "../../../../utils/number.utils";
import CheckIcon from "../_icons/CheckIcon";

export function DefaultIcon() {
  return (
    <Flex
      justify="center"
      align="center"
      className="size-8 p-2 rounded-full border border-theme-yellow-500"
    >
      <div className="size-2.5 bg-theme-yellow-400 rounded-full" />
    </Flex>
  );
}

type ActiveIconProps = {
  idx: number;
};

export function ActiveIcon({ idx }: ActiveIconProps) {
  return (
    <Flex
      justify="center"
      align="center"
      className="size-8 rounded-full border bg-theme-yellow-400 border-theme-yellow-500"
    >
      <span className="text-base inline-block mt-[1px]">
        {enToBnNumber(idx + 1)}
      </span>
    </Flex>
  );
}

export function CompleteIcon() {
  return (
    <Flex
      justify="center"
      align="center"
      className="size-8 rounded-full border bg-theme-primary border-theme-primary"
    >
      <CheckIcon />
    </Flex>
  );
}
